import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Span } from '../../../layouts';
import { FaresCalendarLegendEl } from './FaresCalendarLegend.style';
import { ABUtils } from '../../../utils';

export const FaresCalendarLegend = ({ extraMarginLeft }) => {
    const { t } = useTranslation();
    const { isCssVariationMobile } = ABUtils.getABs();
    const wrapperClassName = classNames({
        'prisma-responsive-space-horizontal odf-space-outer-top-s odf-space-outer-bottom-s': isCssVariationMobile,
        'odf-flex-container-row': true,
    });
    return (
        <FaresCalendarLegendEl
            className={wrapperClassName}
            extraMarginLeft={extraMarginLeft}
        >
            <div className="odf-flex-item odf-flex-item-sm odf-flex-container-row odf-space-outer-right-s">
                <div className="odf-space-outer-right-xs odf-calendar-price-legend-unknown">
                    <Span
                        className="odf-icon odf-icon-m odf-icon-more"
                        position="relative"
                        left="1px"
                        bottom={isCssVariationMobile ? '2px' : '5px'}
                    />
                </div>
                <span className="odf-text-xs">{t('calendar.prices.legend.unknown')}</span>
            </div>
            <div className="odf-flex-item odf-flex-item-sm odf-flex-container-row">
                <div className="odf-space-outer-right-xs odf-calendar-price-legend-cheap" />
                <span className="odf-text-xs">{t('calendar.prices.legend.cheap')}</span>
            </div>
        </FaresCalendarLegendEl>
    );
};

FaresCalendarLegend.propTypes = {
    extraMarginLeft: PropTypes.bool,
};
FaresCalendarLegend.defaultProps = {
    extraMarginLeft: false,
};
